import { Wordmark } from './Wordmark'

/**
 * Canon (ADR-001 2026-07-11): the wordmark is NEVER paired with an icon.
 * This used to render BrandMark + Space Grotesk "mindhunters"; it now renders
 * the canonical <Wordmark> alone. Kept as a thin alias for import stability.
 */
export function MindhuntersLogo({ className }: { className?: string }) {
  return <Wordmark size="md" className={className} />
}
